<template>
  <j-modal :title="title" width="60%" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
    :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }">
    <a-spin :spinning="confirmLoading">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备ID')">
                <a-input :placeholder="$t('请输入设备ID')" v-model="queryParam.deviceId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-table ref="table" size="middle" :scroll="{ x: true }" bordered :rowKey="getRowKey" :columns="columns"
          :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap"
          :rowSelection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :customRow="customRow" @change="handleTableChange">
        </a-table>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'modal',
  mixins: [JeecgListMixin],
  components: {},
  data() {
    return {
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      disableMixinCreated: true, // 禁用JeecgListMixin自动loadData
      url: {
        list: '/jeecg-gis/nodeIotConfig/pageDevice',
      },
      // 动态表头（在 init 中根据设备类型设置）
      columns: [],
    }
  },
  computed: {
    title() {
      return this.$t('物联设备')
    },
    // i18n：表头使用 computed 以响应语言切换
    columns_1() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('设备ID'),
          align: 'center',
          dataIndex: 'deviceId',
          customRender: (t, r) => {
            return r.device && r.device.deviceId
          }
        },
        {
          title: this.$t('设备名称'),
          align: 'center',
          dataIndex: 'deviceName',
          customRender: (t, r) => {
            return r.device && r.device.deviceName
          }
        },
        {
          title: this.$t('安装位置'),
          align: 'center',
          dataIndex: 'deviceLocation',
          customRender: (t, r) => {
            return r.device && r.device.deviceLocation
          }
        },
        {
          title: this.$t('压力(Mpa)'),
          align: 'center',
          dataIndex: 'pvalue',
          customRender: (t, r) => {
            return r.iotData && r.iotData.pvalue
          },
        },
        {
          title: this.$t('温度(℃)'),
          align: 'center',
          dataIndex: 'tepvalue',
          customRender: (t, r) => {
            return r.iotData && r.iotData.tepvalue
          },
        },
        {
          title: this.$t('电压(V)'),
          align: 'center',
          dataIndex: 'battery',
          customRender: (t, r) => {
            return r.iotData && r.iotData.battery
          },
        },
        {
          title: this.$t('信号(%)'),
          align: 'center',
          dataIndex: 'signDb',
          customRender: (t, r) => {
            return r.iotData && r.iotData.signDb
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'metertime',
          customRender: (t, r) => {
            return r.iotData && r.iotData.metertime
          },
        },
      ]
    },
    columns_2() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('设备代码'),
          align: 'center',
          dataIndex: 'deviceCode',
          customRender: (t, r) => {
            return r.device && r.device.deviceCode
          }
        },
        {
          title: this.$t('设备名称'),
          align: 'center',
          dataIndex: 'deviceName',
          customRender: (t, r) => {
            return r.device && r.device.deviceName
          }
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterId
          },
        },
        {
          title: this.$t('累计用量(m³)'),
          align: 'center',
          dataIndex: 'meterTotalUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterTotalUse
          },
        },
        {
          title: this.$t('结算日流量(m³)'),
          align: 'center',
          dataIndex: 'meterJsrUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterJsrUse
          },
        },
        {
          title: this.$t('表端剩余金额(元)'),
          align: 'center',
          dataIndex: 'meterRemainNum',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterRemainNum
          },
        },
        {
          title: this.$t('电压(V)'),
          align: 'center',
          dataIndex: 'meterBatteryVoltage',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterBatteryVoltage
          },
        },
        {
          title: this.$t('信号(%)'),
          align: 'center',
          dataIndex: 'meterSignalStrength',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterSignalStrength
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'sysTime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.sysTime
          },
        },
      ]
    },
    // 其他设备类型（阀门、消防栓、水塔、加压泵、流量计、液位计）的默认列
    columns_default() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('设备ID'),
          align: 'center',
          dataIndex: 'deviceId',
          customRender: (t, r) => {
            return r.device && r.device.deviceId
          }
        },
        {
          title: this.$t('设备名称'),
          align: 'center',
          dataIndex: 'deviceName',
          customRender: (t, r) => {
            return r.device && r.device.deviceName
          }
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'lastUpdateTime',
          customRender: (t, r) => {
            return r.iotData && r.iotData.lastUpdateTime
          },
        },
        {
          title: this.$t('最新上报值'),
          align: 'center',
          dataIndex: 'value',
          customRender: (t, r) => {
            return r.iotData && r.iotData.value
          },
        },
      ]
    },
  },
  methods: {
    // 兼容多种数据结构获取唯一标识
    getRowKey(record) {
      return record.deviceId
        || record.id
        || (record.device && (record.device.deviceId || record.device.id))
        || (record.iotData && record.iotData.meterId)
        || record.meterId
        || record._idx
    },
    getRecordDeviceId(record) {
      return record.deviceId
        || record.id
        || (record.device && (record.device.deviceId || record.device.id))
        || (record.iotData && record.iotData.meterId)
        || null
    },
    init(row) {
      this.visible = true
      // 重置状态，防止串数据
      this.selectedRowKeys = []
      this.selectionRows = []
      this.dataSource = []
      this.ipagination.current = 1
      this.queryParam.deviceId = ''
      this.$set(this.queryParam, 'nodeType', row.node.type)
      // 根据设备类型切换列配置
      switch (row.node.type) {
        case 'NODE_PIPELINE_TYPE_PM':
          this.columns = this.columns_1
          break
        case 'NODE_PIPELINE_TYPE_METER':
          this.columns = this.columns_2
          break
        default:
          // 其他设备类型使用默认列
          this.columns = this.columns_default
          break
      }
      this.loadData(1)
      if (row.nodeIotConfig) {
        const configDeviceId = row.nodeIotConfig.deviceId || (row.nodeIotConfig.device && row.nodeIotConfig.device.deviceId)
        this.selectedRowKeys = [configDeviceId]
        this.selectionRows = [row.nodeIotConfig]
      }
    },
    customRow(record, index) {
      const key = this.getRecordDeviceId(record)
      return {
        on: {
          click: e => {
            this.selectionRows = [record]
            this.selectedRowKeys = [key]
          },
        },
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    loadData() {
      if (this.queryParam.nodeType) {
        let params = {
          nodeType: this.queryParam.nodeType,
          deviceId: this.queryParam.deviceId,
          page: {
            current: this.ipagination.current,
            size: this.ipagination.pageSize,
          },
        }
        postAction(this.url.list, params).then(res => {
          if (res.success) {
            // 展平嵌套数据，让列直接用 dataIndex 匹配
            this.dataSource = res.result.records.map(r => ({
              ...r,
              deviceId: r.device && r.device.deviceId,
              deviceName: r.device && r.device.deviceName,
              deviceLocation: r.device && r.device.deviceLocation,
              deviceCode: r.device && r.device.deviceCode,
              meterId: r.iotData && r.iotData.meterId,
            }))
            this.ipagination.total = res.result.total
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    searchReset() {
      this.queryParam.deviceId = ''
      this.ipagination.current = 1
      this.loadData(1)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.warning(this.$t('请选择物联设备！'))
        return
      }
      this.$emit('ok', this.selectionRows[0])
      this.visible = false
    },
  },
}
</script>